// extracted by mini-css-extract-plugin
module.exports = {"root":"p_bY"};